import { PureComponent } from 'react';
import FnExpression from './FnExpression';
import ExpressionSelector, { Container } from './ExpressionSelector/ExpressionSelector';
import type { FormulaNode, UiFormulaNode } from '../typeDefs';

interface IfExpressionProps {
    data: UiFormulaNode;
}

export default class IfExpression extends PureComponent<IfExpressionProps> {
    static getStub = (): FormulaNode => ({
        $op: 'if',
        $value: FnExpression.getStub(),
        $then: FnExpression.getStub(),
        $else: { ...FnExpression.getStub(['constant']), $args: ['false'] },
    });

    render() {
        const { data: { depth, getChildPath, getChildLogResult } } = this.props;

        return <div className='expression-if'>
            <ExpressionSelector depth={depth + 1} noRemove={true} path={getChildPath('$value')} />

            <Container
                displayArgs={{
                    type: 'if',
                    parentType: 'if',
                    result: getChildLogResult('$then'),
                    root: true,
                }}
                label='Then:'
                style={{ marginLeft: '-.5rem' }}
            />

            <ExpressionSelector depth={depth + 1} noRemove={true} path={getChildPath('$then')} />

            <Container
                displayArgs={{
                    type: 'if',
                    parentType: 'if',
                    result: getChildLogResult('$else'),
                    root: true,
                }}
                label='Else:'
                style={{ marginLeft: '-.5rem' }}
            />

            <ExpressionSelector depth={depth + 1} data-last-child noRemove={true} path={getChildPath('$else')} />
        </div>;
    }
}
